/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, toConsumableArray as _toConsumableArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Dropdown } from '@carbon/react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import _translateWithId from '../../EnhancedDataTable/misc/translation.js';

var _excluded = ["columnKey", "mode", "filterAllLabel", "items", "initialSelectedItem", "label", "onChange", "titleText"];
var hoc = function hoc(WrappedComponent) {
  return function (_ref) {
    var columnKey = _ref.columnKey,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'live' : _ref$mode,
      filterAllLabel = _ref.filterAllLabel,
      items = _ref.items,
      initialSelectedItem = _ref.initialSelectedItem,
      label = _ref.label,
      onChange = _ref.onChange,
      titleText = _ref.titleText,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var augmentedOnChange = function augmentedOnChange(args) {
      if (args && args.selectedItem && args.selectedItem.label === filterAllLabel) {
        onChange({
          selectedItem: undefined,
          columnKey: columnKey,
          mode: mode
        });
      } else {
        onChange(_objectSpread2(_objectSpread2({}, args), {}, {
          columnKey: columnKey,
          mode: mode
        }));
      }
    };

    // include "All" option if filterAllLabel specified
    var allOption = filterAllLabel ? [{
      id: filterAllLabel,
      label: filterAllLabel
    }] : [];
    var augmentedItems = [].concat(allOption, _toConsumableArray(items));
    var augmentedInitialSelectedItem = initialSelectedItem && initialSelectedItem[0] && String(initialSelectedItem[0].label) || filterAllLabel;
    return /*#__PURE__*/React.createElement(WrappedComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      translateWithId: function translateWithId(id) {
        return _translateWithId(id, t);
      },
      items: augmentedItems,
      initialSelectedItem: augmentedInitialSelectedItem,
      label: label,
      onChange: augmentedOnChange,
      titleText: titleText !== null && titleText !== void 0 ? titleText : label
    }));
  };
};
var TableToolbarDropdown = hoc(Dropdown);
var TableToolbarDropdown$1 = TableToolbarDropdown;

export { TableToolbarDropdown$1 as default };
